'use client';

import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { formatNumberAsCurrencyString } from '@sola/cart-sdk/utils/amount.ts';

import { FieldProps } from '../field/field.tsx';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';

export type NumberFieldProps = InputFieldProps & {
  max?: FieldProps['max'];
  min?: FieldProps['min'];
  isCurrency?: boolean;
  allowScientific?: boolean;
};

export const NumberField: React.FC<NumberFieldProps> = ({
  isCurrency = true,
  allowScientific,
  ...fieldProps
}) => {
  const { name } = fieldProps;
  const { setValue, getValues } = useFormContext();

  // Set the field value to currency
  useEffect(() => {
    if (!name) {
      return;
    }
    const value = getValues()[name];
    if (isCurrency && value) {
      setValue(name, formatNumberAsCurrencyString(value));
    }
  }, []);

  return (
    <InputField
      valueAsNumber
      type="number"
      {...(!allowScientific && {
        // Handle pasting - catches most, but multiple pastes can bypass (would have to loop through each char instead)
        illegalCharsRegex: /[e|E|+|-|,]/g,
        // Handle typing - without it still allows "e"
        onKeyDown: (e) => {
          if (['e', 'E', '+', '-', ','].includes(e.key)) {
            e.preventDefault();
          }
        },
      })}
      {...fieldProps}
    />
  );
};
